import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from '~/services/api/gameApi'
import {
  getListScoreAddressSuccess,
  getListScoreAddressFailed,
  GET_LIST_SCORE_ADDRESS_START,
} from '~/views/app/redux/actions/user'

/**
 * get score by wallet api
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */

const getScoreAddressApi = (props) => {
  var uri = `/api/game/user-score/get-by-wallet`
  return api.post(uri, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */

function* doGetScoreAddress(action) {
  try {
    const response = yield call(getScoreAddressApi, action?.payload)
    yield put(getListScoreAddressSuccess(response))
    // Call callback action if provided
    if (action.onSuccess) {
      yield action.onSuccess(response)
    }
  } catch (error) {
    yield put(getListScoreAddressFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}
/**
 * [Watcher]
 * Watch get score by wallet
 */
export default function* watchGetScoreAddress() {
  yield takeLatest(GET_LIST_SCORE_ADDRESS_START, doGetScoreAddress)
}
